import styled from "styled-components";

export const Container = styled.main`
    height: 100vh;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 36px;
    width: 30%;
    padding: 8px;

    align-items: center;
`;

export const ContentImage = styled.div`
    display: flex;
    justify-content: center;
    width: 200px;
`;

export const Image = styled.img`
    width: 100%;
`;

export const Header = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
`;

export const H3 = styled.h3`
`;

export const TextP = styled.p`
    font-size: 14px;
    color: ${(props) => props.theme.colors.gray.gray_600};
    text-align: center;

    span{
        color: ${(props) => props.theme.colors.primary};
    }
`;

export const Forms = styled.form`
    display: flex;
    flex-direction: column;
    gap: 36px;
    `;

export const InputForms = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    gap: 4px;
`;

export const Label = styled.label`
    color: ${(props) => props.theme.colors.gray.gray_600};
`;

export const ContentInput = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
    `;

export const Input = styled.input`
    background-color: transparent;
    &::placeholder{
        color: ${(props) => props.theme.colors.gray.gray_200};
    }
    border-bottom: 1px solid ${(props) => props.theme.colors.gray.gray_600};
    padding: 10px;
`;

export const InforErro = styled.div`
    color: ${(props) => props.theme.colors.primary};
    font-size: 12px;
`;

export const Footer = styled.footer`
    display: flex;
    align-items: center;
    gap: 5px;
    color: ${(props) => props.theme.colors.gray.gray_600};
`;

export const ReturnPageLogin = styled.p`
    font-size: 14px;
    span{
        margin-left: 3px;
        color: ${(props) => props.theme.colors.primary};
        text-decoration: underline;
    }
`;